module Meevo.Plugins.PosHardware {
  "use strict";

  /**
  * Pos Station Section of PosHardware 
  */
  export class PosStationSection extends Meevo.Components.CommonClasses.CommonSectionBase {

  }
}